import styled from '@emotion/styled'
import { palette, spacing, Text } from 'main/ui'
import { darken } from 'polished'

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`

export const StyledText = styled(Text)`
  color: ${palette.skyBlue2};
  cursor: pointer;
  margin: ${spacing.minorScale(1)}px 0;

  &:hover {
    color: ${darken(0.1, palette.skyBlue2)};
  }
`
